<template>
  <div class="my-4 ma-md-5 mx-lg-12">
    <v-row
      no-gutters
      v-bind:class="[
        'mx-2 align-center',
        {
          'flex-column justify-center': !$vuetify.breakpoint.mdAndUp,
        },
      ]"
    >
    </v-row>
    <template>
      <v-row class="titleMobile"
      :style="{gap: '1rem'}">
        <v-btn
          class="back"
          dark
          icon
          to="/configuration"
        >
          <v-icon
          :style="{color: '#27846d !important', fontSize: '34px'}"
          >
            icon-ayudadigital-volver
          </v-icon>
        </v-btn>
        <h2> {{ $t('views.configuration.applications.title') }} </h2>
      </v-row>
      <div class="plantillaSuscrip">
        <v-row>
          <v-col cols="12">
            <ApplicationConfiguration
              :applications="applications"
            />
          </v-col>
        </v-row>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { ApplicationConfiguration } from '@/components';

export default {
  name: 'ConfigurationApplications',
  components: { ApplicationConfiguration },
  data() {
    return {

    };
  },
  props: {
    applications: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
  },
  methods: {
    isCitizen() {
      return this.user.hasIosUser();
    },
  },
  created() {
    if (this.isCitizen()) {
      this.$store.dispatch('messages/createNotificationMessage', {
        title: 'No tienes acceso para visualizar este módulo',
        type: 'error',
        timeout: this.$getConst('notifications.timeoutPlus'),
        dismissible: true,
      });
      this.$router.push('/');
    }
  },
};
</script>
<style lang="scss" scoped>
$header-padding: 10 0;

  .v-menu__content{
      margin-top:2.5rem;
      box-shadow: none !important;
  }

  .plantillaSuscrip {
    background-color: white;
    /* padding: 1em 0em; */
    margin-bottom: 1em;
    margin-top: 1em;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 7%),
    0px 2px 2px 0px rgb(0 0 0 / 5%), 0px 1px 5px 0px rgb(0 0 0 / 5%);
  }

  .card {
    flex: 0 0 33.3333%;
  }

  @media (max-width: 900px) {

    .card.v-card {
      flex: initial;
      flex-direction: column;
    }
    .inputSearch{
        margin-top: 0px !important;
        padding-top: 0px !important;
    }
  }
  @media (max-width: 600px) {
    .btn__suscripciones {
      margin-left: 0;
    }
    div.v-slide-group__content {
      flex-wrap: wrap !important;
      width: 100% !important;
      background-color: red;
    }
    .inputSearch{
        margin-top: 0px !important;
        padding-top: 0px !important;
    }
  }
  @media (max-width: 768px) {
    .titleMobile{
      margin-left: 0rem !important;
    }
  }

</style>
